import styled, { css } from 'styled-components';

import { Text } from 'shared/components/Text/Text';

export const VideoCardMainBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const VideoPlayerContainer = styled.div`
  position: relative;
  height: 250px;
  margin-bottom: 24px;
  border-radius: 1px;
  cursor: pointer;
`;

export const VideoPlayerCard = styled.iframe`
  border: 1px;
  width: 100%;
  border-radius: 10px;
`;

export const VideoCardTitle = styled(Text)`
  ${({ theme }) => css`
    display: flex;
    font-weight: 500;
    color: ${theme.colors.textPrimarySecondary1100};
    line-height: 1.5;
    svg {
      margin-left: auto;
      path {
        fill: ${theme.colors.buttonButtonPrimarySecondary2100};
      }
    }
  `}
`;

export const VideoCardDescription = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.textSecondarySubtleGrey80};
    margin: 12px 0 0 0;
    font-size: 16px;
    line-height: 1.5;
    font-weight: 400;
    background: unset;
  `}
`;

export const VideoPlayerMask = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
`;

export const VideoPlayerWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;
